import GenerateTeams from './GenerateTeams';
export default GenerateTeams;
